import { Button, Col, Label } from "reactstrap";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import FormAssessmentKelompok from "../components/FormAssessmentKelompok";
import DetailHeader from "../components/DetailHeader";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import useAxios from "../../../Utils/useAxios";
import getUnitKerja from "../services/getUnitKerja";
import getStaff from "../services/getUser";
import ListStafByUnitKerja from "../components/ListStafByUnitKerja";
import getStaffByUnitKerja from "../services/getStaffByUnitKerja";
import DetailPetunjukUmum from "../components/DetailPetunjukUmum";
import getAsesmenKelompokAssessedBy from "../services/getAsesmenKelompokAssessedBy";
import getAsesmenPredikatByList from "../services/getAsesmenPredikatByList";
import getAsesmenKelompokFunction from "../utils/getAsesmenKelompokFunction";
import { getUnitKerjaStorage } from "../../../Utils/externalFunctions";
import { ASESMEN_TYPE, PetunjukUmumKelompok } from "../constants";

const AssessmentKelompokContain = () => {
  const [data, setData] = useState({
    staf: [],
    stafUnitKerja: [],
    unitKerja: [],
    asesmenKelompok: [],
    asesmenPredikat: [],
  });
  const [selectedUnitKerja, setSelectedUnitKerja] = useState();
  const [selectedAssessedBy, setSelectedAssessedBy] = useState(
    getUnitKerjaStorage()
  );

  const axiosInstance = useAxios();

  useEffect(() => {
    const fetchData = () => {
      refreshStaff();
      refreshStaffByUnitKerja();
      refreshUnitKerja();
      refreshAsesmenKelompok();
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      refreshStaffByUnitKerja();

      const asesmenKelompok = getAsesmenKelompokFunction(
        data,
        selectedUnitKerja,
        selectedAssessedBy
      );

      if (asesmenKelompok) {
        getAsesmenPredikatByList(
          axiosInstance,
          asesmenKelompok?.predikats
        ).then((res) => {
          setData((prev) => ({ ...prev, asesmenPredikat: res.data }));
        });
      } else {
        setData((prev) => ({ ...prev, asesmenPredikat: [] }));
      }
    };

    fetchData();
  }, [selectedUnitKerja, selectedAssessedBy]);

  const refreshStaff = () => {
    getStaff(axiosInstance).then((res) =>
      setData((prev) => {
        return {
          ...prev,
          staf: res.data,
        };
      })
    );
  };
  const refreshStaffByUnitKerja = () => {
    if (selectedUnitKerja)
      getStaffByUnitKerja(axiosInstance, selectedUnitKerja).then((res) =>
        setData((prev) => {
          return {
            ...prev,
            stafUnitKerja: res.data,
          };
        })
      );
  };
  const refreshUnitKerja = () => {
    getUnitKerja(axiosInstance).then((res) => {
      res.data.sort((a, b) => {
        return a.nama_unit_kerja > b.nama_unit_kerja ? 1 : -1;
      });

      setData((prev) => ({
        ...prev,
        unitKerja: res.data,
      }));
    });
  };
  const refreshAsesmenKelompok = () => {
    getAsesmenKelompokAssessedBy(axiosInstance).then((res) => {
      setData((prev) => ({ ...prev, asesmenKelompok: res.data }));
    });
  };

  const updateUnitKerja = (newUnitKerja) => setSelectedUnitKerja(newUnitKerja);
  const updateAssessedBy = (newUnitKerja) =>
    setSelectedAssessedBy(newUnitKerja);

  return (
    <FeatureContainer>
      <div className="px-4">
        <Link to={`/dashboard`}>
          <Button>Kembali ke Dashboard</Button>
        </Link>
      </div>
      <Col
        sm={{
          offset: 1,
          size: 10,
        }}
      >
        <Label className={"d-flex justify-content-center h4"}>
          <strong>Formulir Penilaian Kinerja Kelompok</strong>
        </Label>
        <DetailHeader
          className={"py-4"}
          data={data}
          type={ASESMEN_TYPE.Kelompok}
          updateUnitKerja={updateUnitKerja}
          updateAssessedBy={updateAssessedBy}
        />
        <ListStafByUnitKerja data={data} />
        <DetailPetunjukUmum
          className={"my-2 pb-4"}
          petunjukUmum={PetunjukUmumKelompok}
        />
        <FormAssessmentKelompok
          data={data}
          selectedUnitKerja={selectedUnitKerja}
          selectedAssessedBy={selectedAssessedBy}
        />
      </Col>
    </FeatureContainer>
  );
};

export default AssessmentKelompokContain;
